// At most one prompt that opens by itself per day (plans reminder, referral, install
// the app). Milestones answer the user's own action, so they always show, but they
// use up the day too. Per browser, like the other prompts' "not now" memory.
const KEY = "ordexa/nudge-day";

// Local date: the UTC one would start a new "day" at 21h in Brazil.
function today() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

// Only one celebration/prompt modal per page load: a second one waits for the next load.
let shownThisLoad = false;

export function modalShownThisLoad() {
  return shownThisLoad;
}

export function markModalShown() {
  shownThisLoad = true;
}

export function canNudge() {
  if (shownThisLoad) return false;
  try {
    return localStorage.getItem(KEY) !== today();
  } catch (e) {
    return false;
  }
}

export function useNudge() {
  try {
    localStorage.setItem(KEY, today());
  } catch (e) {
    /* private mode: prompts just stay quiet */
  }
}

// True (and the day is used) when nothing else opened by itself today.
export function claimNudge() {
  if (!canNudge()) return false;
  useNudge();
  shownThisLoad = true;
  return true;
}
